import localFont from 'next/font/local'

import type { Language } from '@/shared/lib/i18n'

// The dialog lists every language by its native name, so a latin-locale visitor sees CJK glyphs
// that the locale's faces lack. Left to the system fallback, they render differently on every
// machine. Each name is drawn by its own regional Noto Sans CJK face, cut down to just the
// glyphs of that name (about 2 KB per file instead of ~170 KB of Google unicode-range slices).
//
// The files carry nothing but these glyphs, so a renamed language needs a new subset. Cut it from
// the variable font in google/fonts (`ofl/notosans<region>/NotoSans<Region>[wght].ttf`):
//   pyftsubset 'NotoSansJP[wght].ttf' --text='日本語' --layout-features='*' --flavor=woff2 \
//     --output-file=noto-sans-jp-language-name.woff2
const japaneseNameFont = localFont({
    src: './font-files/noto-sans-jp-language-name.woff2',
    weight: '100 900',
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

const koreanNameFont = localFont({
    src: './font-files/noto-sans-kr-language-name.woff2',
    weight: '100 900',
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

const simplifiedChineseNameFont = localFont({
    src: './font-files/noto-sans-sc-language-name.woff2',
    weight: '100 900',
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

const traditionalChineseNameFont = localFont({
    src: './font-files/noto-sans-tc-language-name.woff2',
    weight: '100 900',
    display: 'swap',
    preload: false,
    adjustFontFallback: false,
})

export const languageNameFonts: Partial<Record<Language, { className: string }>> = {
    ja: japaneseNameFont,
    ko: koreanNameFont,
    cn: simplifiedChineseNameFont,
    tw: traditionalChineseNameFont,
}
